import { SearchTarget } from '@/types'

export interface BibliographyAuthorityAuthorSearchRequest {
  searchTarget: SearchTarget
  numberOfLimit: number
  author: string
  authorNo: string
}

export function BibliographyAuthorityAuthorSearchRequestToJSON(
  value: BibliographyAuthorityAuthorSearchRequest
): any {
  return {
    search_target: value.searchTarget ? value.searchTarget : undefined,
    number_of_limit: value.numberOfLimit ? value.numberOfLimit : undefined,
    author: value.author !== '' ? value.author : undefined,
    author_no: value.authorNo !== '' ? value.authorNo : undefined
  }
}
